import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import { shortenandHoverString } from '../../helper';
import { EditIcon, UserManagementIcon, DeleteIcon } from '../../../bombiix-icon';
import { NewCheckbox } from '../../PIM/common';

function UserGroupsCard({ item, onCheck, index, selectedIds, onDelete, onEdit, editeble }) {
  const [element, setElement] = useState(null);
  const isChecked = selectedIds.filter((val) => val === item._id).length > 0;
  const { t } = useTranslation('common');

  useEffect(() => {
    const value = item ? { ...item } : null;
    setElement(value);
  }, [item]);

  const handleEdit = (id) => {
    onEdit(id);
  };

  const checkLabel = () => {
    return (
      <li>
        <div className="d-inline-flex">
          <NewCheckbox
            size="sm"
            onChange={(e) => {
              onCheck(e, item._id, index);
            }}
            name={`check_${index}`}
            id={`check_${index}`}
            checked={isChecked}
          />
        </div>
      </li>
    );
  };

  return (
    <div id="accordion" className="col-lg-3 user-group-card">
      <div className="common-listing-card card mt-5">
        <div className="card-header">
          <ul className="card-header-icon">
            {checkLabel()}
            {editeble && (
              <li>
                <a href={() => false} onClick={() => handleEdit(element._id)} title={t('USER_GROUPS_CARD.EDIT_TITLE')}>
                  <EditIcon size={24} />
                </a>
              </li>
            )}
            <li>
              <Link
                className="cursor-pointer text-dark text-decoration-none"
                title={t('USER_GROUPS_CARD.USER_RIGHTS_TITLE')}
                to={`/settings/users/${element?._id}`}
              >
                <UserManagementIcon size={24} />
              </Link>
            </li>
            <li>
              <a
                href={() => false}
                title={t('USER_GROUPS_CARD.DELETE_TITLE')}
                onClick={() => {
                  onDelete(element._id);
                }}
              >
                <DeleteIcon size={24} />
              </a>
            </li>
          </ul>
        </div>
        <div className="card-body">
          <ul className="card-ul">
            <li>
              <strong>{t('USER_GROUPS_CARD.GROUP_NAME')}: </strong>
              <span>{element?.name ? shortenandHoverString(element.name, 15) : ''}</span>
            </li>
            <li className="d-flex">
              <strong>{t('USER_GROUPS_CARD.GROUP_MEMBERS')}: </strong>
              {' '}
              <span className="d-inline-block text-truncate" style={{ maxWidth: '150px' }}>
                {!isEmpty(element?.users)
                  ? shortenandHoverString(
                      [...new Map(element.users.map((u) => [u?._id ?? u?.id, u])).values()]
                        .map((u) => u?.firstName)
                        .filter(Boolean)
                        .join(', '),
                      15,
                    )
                  : ' -'}
              </span>
            </li>
            <li>
              <strong>{t('USER_GROUPS_CARD.BRAND')}: </strong>
              <span>
                {element?.brand
                  ? shortenandHoverString(
                      element.brand.map((ele, i) => (element.brand.length - 1 === i || element.brand.length === 1 ? ele.name : `${ele.name},`)).join(' '),
                      30,
                    )
                  : ''}
              </span>
            </li>
            <li>
              <strong>{t('USER_GROUPS_CARD.CATEGORY_ONE')}: </strong>
              <span>
                {element?.catOne
                  ? shortenandHoverString(
                      element.catOne.map((ele, i) => (element.catOne.length - 1 === i || element.catOne.length === 1 ? ele.name : `${ele.name},`)).join(' '),
                      30,
                    ) // element.catOne.map((ele, i) => (element.catOne.length - 1 === i || element.catOne.length === 1 ? ele.name : `${ele.name},`))
                  : ''}
              </span>
            </li>
            <li>
              <strong>{t('USER_GROUPS_CARD.CATEGORY_TWO')}: </strong>
              <span>
                {element?.catTwo
                  ? shortenandHoverString(
                      element.catTwo.map((ele, i) => (element.catTwo.length - 1 === i || element.catTwo.length === 1 ? ele.name : `${ele.name},`)).join(' '),
                      30,
                    )
                  : ''}
              </span>
            </li>
            <li>
              <strong>{t('USER_GROUPS_CARD.SUPPLIERS')}: </strong>
              <span>
                {element?.supplier
                  ? shortenandHoverString(
                      element.supplier
                        .map((ele, i) => (element.supplier.length - 1 === i || element.supplier.length === 1 ? ele.firstName : `${ele.firstName},`))
                        .join(' '),
                      30,
                    )
                  : ''}
              </span>
            </li>
          </ul>
        </div>
        <div className="status " />
      </div>
    </div>
  );
}

export default UserGroupsCard;
